import { render, staticRenderFns } from "./ClientPersonsMeetings.vue?vue&type=template&id=16af8318&scoped=true&"
import script from "./ClientPersonsMeetings.vue?vue&type=script&lang=js&"
export * from "./ClientPersonsMeetings.vue?vue&type=script&lang=js&"
import style0 from "./ClientPersonsMeetings.vue?vue&type=style&index=0&id=16af8318&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16af8318",
  null
  
)

export default component.exports